/** Result displays (ADR-0117): tables, records, maps, networks, timelines, forms, documents, charts. */
export default {
  en: {
    kind: { table: "Results", record: "Record", kv: "Details", list: "List", map: "Map", timeline: "Timeline", network: "Connections", form: "Form", document: "Document", chart: "Chart" },
    loading: "Loading the result…",
    failed: "The result could not be loaded. You may not be allowed to see it, or it is no longer kept.",
    empty: "Nothing to show.",
    items_one: "{{count}} item",
    items_other: "{{count}} items",
    fields_one: "{{count}} field",
    fields_other: "{{count}} fields",
    more_one: "{{count}} more row — show it bigger to see everything.",
    more_other: "{{count}} more rows — show it bigger to see everything.",
    earlier_one: "{{count}} earlier event — show it bigger to see everything.",
    earlier_other: "{{count}} earlier events — show it bigger to see everything.",
    bigger: "Show bigger",
    close: "Close",
    open: "Open",
    sortBy: "Sort by this column",
    tableScroll: "Table of results (scrolls)",
    masked: "Hidden",
    maskedNote: "Some values are hidden because of their data level.",
    map: {
      label_one: "Map with {{count}} place",
      label_other: "Map with {{count}} places",
      list_one: "The place on the map, as a list",
      list_other: "The {{count}} places on the map, as a list",
      place: "Place {{n}}",
      zoomIn: "Zoom in",
      zoomOut: "Zoom out",
      fit: "Fit the map to the results",
      noPlaces: "No places to show on the map.",
    },
    network: {
      label_one: "Connections of {{count}} record",
      label_other: "Connections of {{count}} records",
      legend: "Kinds of record",
      list: "The connections, as a list",
      linkedTo: "Linked to: {{names}}",
      noLinks: "No links",
      types: { person: "Person", phone: "Phone", vehicle: "Vehicle", address: "Address", account: "Account", organisation: "Organisation", case: "Case" },
    },
    form: {
      submit: "Send",
      sent: "Sent. The agent takes it from here.",
      failed: "It could not be sent. Try again.",
      fix_one: "Fix {{count}} field first.",
      fix_other: "Fix {{count}} fields first.",
    },
    document: { open: "Open in a new tab", noPreview: "This file cannot be shown here." },
  },
  ar: {
    kind: { table: "النتائج", record: "سجل", kv: "التفاصيل", list: "قائمة", map: "خريطة", timeline: "التسلسل الزمني", network: "الروابط", form: "نموذج", document: "مستند", chart: "رسم بياني" },
    loading: "جارٍ تحميل النتيجة…",
    failed: "تعذّر تحميل النتيجة. ربما لا يُسمح لك برؤيتها أو لم تعد محفوظة.",
    empty: "لا شيء لعرضه.",
    items_zero: "لا عناصر",
    items_one: "عنصر واحد",
    items_two: "عنصران",
    items_few: "{{count}} عناصر",
    items_many: "{{count}} عنصرًا",
    items_other: "{{count}} عنصر",
    fields_zero: "لا حقول",
    fields_one: "حقل واحد",
    fields_two: "حقلان",
    fields_few: "{{count}} حقول",
    fields_many: "{{count}} حقلًا",
    fields_other: "{{count}} حقل",
    more_zero: "لا صفوف أخرى.",
    more_one: "صف آخر — اعرضها بحجم أكبر لترى كل شيء.",
    more_two: "صفّان آخران — اعرضها بحجم أكبر لترى كل شيء.",
    more_few: "{{count}} صفوف أخرى — اعرضها بحجم أكبر لترى كل شيء.",
    more_many: "{{count}} صفًا آخر — اعرضها بحجم أكبر لترى كل شيء.",
    more_other: "{{count}} صف آخر — اعرضها بحجم أكبر لترى كل شيء.",
    earlier_zero: "لا أحداث سابقة.",
    earlier_one: "حدث سابق — اعرضها بحجم أكبر لترى كل شيء.",
    earlier_two: "حدثان سابقان — اعرضها بحجم أكبر لترى كل شيء.",
    earlier_few: "{{count}} أحداث سابقة — اعرضها بحجم أكبر لترى كل شيء.",
    earlier_many: "{{count}} حدثًا سابقًا — اعرضها بحجم أكبر لترى كل شيء.",
    earlier_other: "{{count}} حدث سابق — اعرضها بحجم أكبر لترى كل شيء.",
    bigger: "اعرض بحجم أكبر",
    close: "إغلاق",
    open: "فتح",
    sortBy: "رتّب حسب هذا العمود",
    tableScroll: "جدول النتائج (قابل للتمرير)",
    masked: "مخفي",
    maskedNote: "بعض القيم مخفية بسبب مستوى سرّيتها.",
    map: {
      label_zero: "خريطة بلا أماكن",
      label_one: "خريطة بمكان واحد",
      label_two: "خريطة بمكانين",
      label_few: "خريطة بـ {{count}} أماكن",
      label_many: "خريطة بـ {{count}} مكانًا",
      label_other: "خريطة بـ {{count}} مكان",
      list_zero: "لا أماكن على الخريطة",
      list_one: "المكان على الخريطة كقائمة",
      list_two: "المكانان على الخريطة كقائمة",
      list_few: "الأماكن الـ {{count}} على الخريطة كقائمة",
      list_many: "الأماكن الـ {{count}} على الخريطة كقائمة",
      list_other: "الأماكن الـ {{count}} على الخريطة كقائمة",
      place: "المكان {{n}}",
      zoomIn: "تكبير",
      zoomOut: "تصغير",
      fit: "اضبط الخريطة على النتائج",
      noPlaces: "لا أماكن لعرضها على الخريطة.",
    },
    network: {
      label_zero: "لا روابط",
      label_one: "روابط سجل واحد",
      label_two: "روابط سجلّين",
      label_few: "روابط {{count}} سجلات",
      label_many: "روابط {{count}} سجلًا",
      label_other: "روابط {{count}} سجل",
      legend: "أنواع السجلات",
      list: "الروابط كقائمة",
      linkedTo: "مرتبط بـ: {{names}}",
      noLinks: "لا روابط",
      types: { person: "شخص", phone: "هاتف", vehicle: "مركبة", address: "عنوان", account: "حساب", organisation: "جهة", case: "قضية" },
    },
    form: {
      submit: "إرسال",
      sent: "تم الإرسال. يتابع الوكيل من هنا.",
      failed: "تعذّر الإرسال. حاول مرة أخرى.",
      fix_zero: "لا حقول تحتاج إلى تصحيح.",
      fix_one: "صحّح حقلًا واحدًا أولًا.",
      fix_two: "صحّح حقلين أولًا.",
      fix_few: "صحّح {{count}} حقول أولًا.",
      fix_many: "صحّح {{count}} حقلًا أولًا.",
      fix_other: "صحّح {{count}} حقل أولًا.",
    },
    document: { open: "افتح في علامة تبويب جديدة", noPreview: "لا يمكن عرض هذا الملف هنا." },
  },
};
